import { createContext, useContext, type ReactNode } from "react";
import type { SessionUser } from "@alpha/shared";
import { api } from "./api";
import { ErrorBox, Loading } from "./components/ui";
import { useAsync } from "./useAsync";

const MeContext = createContext<SessionUser | null>(null);

/** Loads the signed-in user (id, tenant, role) from the API once. Used for UI hints only; the API enforces access. */
export function MeProvider({ children }: { children: ReactNode }) {
  const { data, error, loading, reload } = useAsync((signal) => api.get<SessionUser>("/v1/me", signal), []);
  if (loading) return <Loading />;
  if (error || !data) return <ErrorBox error={error} onRetry={reload} />;
  return <MeContext.Provider value={data}>{children}</MeContext.Provider>;
}

export function useMe(): SessionUser {
  const me = useContext(MeContext);
  if (!me) throw new Error("useMe outside MeProvider");
  return me;
}
